import { type YDatabase } from '@databases/collab/y-database';
import { type YField } from '@databases/collab/y-field';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types';

/**
 * Ensures a field exists before a mutation references it. Returns
 * `STATE_ERROR('FIELD_NOT_FOUND')` when the id is absent; otherwise the
 * resolved `YField` so downstream callers avoid a redundant lookup.
 */
export function assertFieldExists(
  ydb: YDatabase,
  fieldId: string
): Result<YField, SdkError> {
  const field = ydb.fieldsById[fieldId];

  if (!field) {
    return err({
      type: 'STATE_ERROR',
      reason: 'FIELD_NOT_FOUND',
      message: `Field '${fieldId}' does not exist`
    });
  }

  return ok(field);
}
